import { MenuItem, Select, styled, TextField, Theme } from '@mui/material';
import {
  BaseStyledMenuItem,
  checkboxStyles,
  ClearIconWrapper,
  createFilterWrapper,
  displayLabelStyles,
  getSelectStyles,
  HoverOverlay,
  StyledClearIcon,
} from '../FilterStyles';

export { HoverOverlay, ClearIconWrapper, StyledClearIcon, displayLabelStyles, checkboxStyles, getSelectStyles };

export const FilterWrapper = createFilterWrapper('fixed-height');

export const StyledMenuItem = styled(BaseStyledMenuItem)(({ theme: { spacing } }) => ({
  paddingTop: spacing(0.5),
  paddingBottom: spacing(0.5),
}));

export const StyledSelect = styled(Select)(() => ({
  position: 'relative',
  fontSize: 16,
  zIndex: 1,
  minWidth: 140,

  '& .MuiSelect-standard': {
    paddingLeft: '14px',
    paddingRight: '14px',
    minWidth: 140,
    maxWidth: 180,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  '& .MuiSelect-icon': {
    color: 'gray',
    marginRight: 6,
  },
}));

export const SearchField = styled(TextField)(({ theme: { spacing } }) => ({
  padding: spacing(1, 2),
  '& .MuiInputBase-root': {
    fontSize: 16,
  },
}));

export const ControlMenuItem = styled(MenuItem)(({ theme: { spacing, palette } }) => ({
  paddingTop: spacing(0.5),
  paddingLeft: 19,
  '&:hover': {
    backgroundColor: palette.action.hover,
  },
}));

export const tooltipItemStyles = {
  py: 0.25,
};

export const paperPropsStyles = {
  minWidth: `200px !important`,
  maxWidth: 272,
  maxHeight: 400,
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  overflow: 'hidden',
  '& .MuiList-root': {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  '& .MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
};

export const searchFieldWrapperStyles = {
  flexShrink: 0,
  paddingTop: 1,
  zIndex: 2,
};

export const scrollableListStyles = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingY: 1,
};

export const getControlMenuItemStyles = ({ palette }: Theme) => ({
  flexShrink: 0,
  backgroundColor: 'background.paper',
  zIndex: 2,
  paddingTop: 1,
  borderTop: '1px solid',
  borderColor: palette.grey[300],
});
